import SuperFetchV2 from '../../../superFetchV2';

import {
  AccountAdminCreateRequest,
  AccountAdminEditPayload,
  AccountAdminListQueryParamType,
  AccountAdminListResponse,
  AdminInfoType,
} from '../../../../views/account/admin/common/types/AccountAdminFormType';
import { removeNull } from '../../../utils';
import queryString from 'query-string';

export const AccountAdminApiV2 = {
  /**
   *  [관리자] 관리자 리스트 요청하기
   */
  getAccountAdminList: (params: AccountAdminListQueryParamType): Promise<AccountAdminListResponse> => {
    const filteredParams = removeNull(params);
    const queryParams = queryString.stringify({ ...filteredParams }, { skipEmptyString: true });
    return SuperFetchV2.get(`/administrators?${queryParams}`);
  },
  /**
   *  [관리자] 관리자 상세정보 요청하기
   */
  getAccountAdminDetailInfo: (id: number): Promise<AdminInfoType> => SuperFetchV2.get(`/administrators/${id}`),

  /**
   *  [관리자] 관리자 등록하기
   */
  createAccountAdminDetailInfo: (data: AccountAdminCreateRequest) => SuperFetchV2.post('/administrators', data),
  /**
   *  [관리자] 관리자 정보 수정하기
   */
  editAccountAdminDetailInfo: (payload: AccountAdminEditPayload) => {
    const { id, data } = payload;
    return SuperFetchV2.patch(`/administrators/${id}`, data);
  },
};
